import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './fonts/index';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import store from './store/store';
import { Provider } from 'react-redux';

const root = createRoot(document.getElementById('root')!);
root.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
);
